import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withComponentInputBinding, withRouterConfig } from '@angular/router';

import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideTranslateService } from '@ngx-translate/core';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { API_BASE, MAX_CACHE_SIZE, FILE_API_BASE_URL } from '@progressio/client-toolkit';
import { OAuthService, provideOAuthClient } from 'angular-oauth2-oidc';
import { AppLanguage } from './core/models/language.model';
import { LanguageService } from './core/services/language.service';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideOptimus } from '@openng/optimus-ui/config';
import { MessageService } from '@openng/optimus-ui/api';
import { AppThemePreset } from './core/config/theme.preset';
import { initAuth } from './core/utils/auth.util';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding(), withRouterConfig({ paramsInheritanceStrategy: 'always' })),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideAnimations(),
    provideOAuthClient({
      resourceServer: {
        allowedUrls: [environment.apiBase],
        sendAccessToken: true,
      },
    }),

    // Optimus Configuration
    provideOptimus({ theme: { preset: AppThemePreset, options: { darkModeSelector: '.app-dark' } } }),

    provideTranslateService({
      lang: AppLanguage.English,
      fallbackLang: AppLanguage.English,
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json',
      }),
    }),
    provideAppInitializer(() => inject(LanguageService).initialize()),
    provideAppInitializer(() => initAuth(inject(OAuthService))()),

    { provide: API_BASE, useValue: environment.apiBase },
    { provide: MAX_CACHE_SIZE, useValue: environment.maxCacheSize },
    { provide: FILE_API_BASE_URL, useValue: environment.fileBase },
    MessageService,
  ],
};
